import { render } from "./AsociaDesasociaRol.vue?vue&type=template&id=6d35b506"
import script from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"
export * from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__